// Salesforce Types
export interface OpportunityBatch {
  name: string;
  description?: string;
  totalAmount: number;
  totalOpportunities: number;
  status: string;
  createdDate: string;
  postedToSageDateTime?: string | null;
}

export interface Opportunity {
  id: string;
  name: string;
  amount: number;
  closeDate: string;
  stageName: string;
  accountName: string;
  batchName?: string;
  allocations: Allocation[];
}

export interface Allocation {
  id: string;
  opportunityId: string;
  amount: number;
  donationChannel: string;
  paymentType: string;
  bankAccount: string;
  contributionCode?: string;
  pfpCode?: string;
  locationCode?: string;
  departmentCode?: string;
  projectCode?: string;
  classCode?: string;
}

// Journal Types Enum (matches original JournalTypes enum)
export enum JournalTypes {
  Bank = 'Bank',
  Revenue = 'Revenue',
  Tax = 'Tax',
  Expense = 'Expense',
}

// Dropdown Item for dimension codes
export interface DropdownItem {
  value: string;
  label: string;
}

// Journal Entry Types (updated to match original Blazor JournalEntry)
export interface JournalEntry {
  id: string;
  journalType: JournalTypes;
  memo: string;
  accountNumber: string;
  accountName: string;
  departmentId: string;
  projectId: string;
  classId: string;
  pfpCode: string;
  contributionCode: string;
  debit: number | null;
  credit: number | null;
  taxId: string;
  taxAmount: number | null;
  description: string;
  locationCode?: string;
  departmentCode?: string;
  projectCode?: string;
  classCode?: string;
  validations: ValidationEvent[];
}

export interface ValidationEvent {
  severity: 'error' | 'warning' | 'info';
  message: string;
  field?: string;
}

// API Response Types
export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  count?: number;
  message?: string;
  error?: {
    message: string;
    stack?: string;
  };
}

export interface JournalBuildResult {
  entries: JournalEntry[];
  totals: JournalTotals;
  opportunityCount: number;
  batchAmount: number;
}

export interface JournalTotals {
  totalDebit: number;
  totalCredit: number;
  bankTotal: number;
  revenueTotal: number;
  balance: number;
  isBalanced: boolean;
}

export interface JournalPostResult {
  success: boolean;
  journalId?: string;
  message: string;
  errors?: string[];
  skippedSagePosting?: boolean;
}

// Dimension Codes Response
export interface DimensionCodes {
  pfpCodes: DropdownItem[];
  contributionCodes: DropdownItem[];
  locationCodes: DropdownItem[];
  bankAccounts: DropdownItem[];
  departmentCodes: DropdownItem[];
  projectCodes: DropdownItem[];
  classCodes: DropdownItem[];
  accountCodes: DropdownItem[];
}
